import React,{useState, useRef} from 'react'
import ListItem from 'jd-library/ListItem'
import Modal from 'jd-library/Modal'
import Image, { AddVideoDiv } from '../../common/product-image/ImageViewUpload';

const DiscountRow = (props) =>{
  return (
    <>
        <div className={'discount-holder'}>
            <ListItem
                className={'normal-menu'}
                leftSection={
                    <div className={"discount-image"}>
                        <Image
                            imageUrl={props.singleData.image_url ? props.singleData.image_url : ''}
                            isReadOnly={true}
                            smallImage={true}
                        />
                    </div>
                }
                middleSection={
                    <div className="mid-section">
                        <div className="discount-prod-title">
                            {props.singleData.product_name}
                        </div>
                        <div className="discount-prod-unit mgb-5">
                            <div className="price-holder">
                                <span className="price-subtitle">Price : &nbsp;</span>
                                <span className="price-selling">₹{props.singleData.mrp} </span>&nbsp;
                                <span>
                                    <b>₹{props.singleData.price}</b>&nbsp;
                                </span>
                                <span className="discount">{props.singleData.discount_percentage}%OFF</span>
                            </div> 
                        </div>
                    </div>

                }
            />
            <div className="card-divider"></div>
        </div>
    </>
  )
}

const BulkDiscountActionModal = (props) =>{
    const [scrolled, setScroll] = useState(false);
    const scrollRef = useRef(null);

    const handleScroll = () => {
        const isScrolled = scrollRef.current.scrollTop > 10;
        if (isScrolled !== scrolled) {
        setScroll(isScrolled);
        }
    };
    return(
        <>
            <Modal
                settings={{
                    modalId: 'center-btn',
                    class: 'discount-action-modal',
                    variant: 'action',
                }}
                onHidden={() => {
                    props.onHidden()
                }}
            >
                <Modal.CloseIcon />
                <Modal.Header className={`discount-header ${scrolled ? "discount-modl-shadow" : ""}`}>
                    {
                        <>
                            <div className="discount-title">{props.title}</div>
                            <div className={`discount-sub-header`}>
                                You have uploaded the following products, which have a discount of more than 25%.
                            </div>
                        </>
                    }    
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <div>
                        <div 
                            className="discount-row-holder"
                            ref={scrollRef}
                            onScroll={handleScroll}
                        >
                            {props.data.length ?
                                props.data.map((cur, index)=>{
                                    return(
                                        <DiscountRow singleData={cur} key={index} />
                                    )
                                })
                                :null
                            }    
                        </div>
                    </div>
                </Modal.Body>
                <Modal.CenterButton 
                    className="fs-sb"
                    variant={props.variant}
                    onClick={()=>{props.onclick()}}
                >
                    {props.btnName}
                </Modal.CenterButton>
            </Modal>
        </>
    )
}


export default BulkDiscountActionModal
